import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Click to upload ")
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "el-upload__tip" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" image files with a size less than 70MB and maximun 20 files. ")
const _hoisted_5 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Clear ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_save_button = _resolveComponent("save-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: _ctx.title,
    width: "30%",
    top: "5vh"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_close_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClose()))
      }),
      _createVNode(_component_save_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSave()))
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, { "max-height": "70vh" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_upload, {
            "file-list": _ctx.fileList,
            "onUpdate:file-list": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
            class: "upload-demo",
            "list-type": "picture",
            accept: "image/*",
            "auto-upload": false,
            multiple: "",
            limit: "20"
          }, {
            tip: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  (_ctx.fileList?.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(`${_ctx.fileList.length} files`), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.fileList?.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      type: "primary",
                      onClick: _cache[0] || (_cache[0] = () => (_ctx.fileList = [])),
                      title: "Clear uploaded files"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                title: "Click to upload"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["file-list"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}